import { Module } from 'vuex';
import { RootState } from '@/app/app.store';

export interface PostPlayerStoreState {
  name: string;
  currentQuality: number;
  player: any;
  hls: any;
}

export const postPlayerStoreModule: Module<PostPlayerStoreState, RootState> = {
  /**
   * 命名空间
   */
  namespaced: true,

  /**
   * 数据
   */
  state: {
    name: 'postPlayerStoreModule',
    currentQuality: 1280,
    player: null,
    hls: null,
  } as PostPlayerStoreState,

  /**
   * 获取器
   */
  getters: {
    post(state, getters, rootState, rootGetters) {
      return rootGetters['post/show/post']
        ? rootGetters['post/show/post']
        : null;
    },

    i18n() {
      return {
        restart: '重播',
        rewind: '后退 {seektime}s',
        play: '播放',
        pause: '暂停',
        fastForward: '前进 {seektime}s',
        seek: '跳转',
        seekLabel: '{currentTime} / {duration}',
        played: '已播',
        buffered: '已缓存',
        currentTime: '当前时间',
        duration: '时长',
        volume: '音量',
        mute: '静音',
        unmute: '取消静音',
        enableCaptions: '启用字幕',
        disableCaptions: '禁用字幕',
        download: '下载',
        enterFullscreen: '进入全屏',
        exitFullscreen: '退出全屏',
        frameTitle: 'Player for {title}',
        captions: '字幕',
        settings: '设置',
        pip: '画中画',
        menuBack: '返回上一级菜单',
        speed: '加速',
        normal: '正常',
        quality: '画质',
        loop: '循环',
        start: '开始',
        end: '结束',
        all: '所有',
        reset: '重置',
        disabled: '禁用',
        enabled: '启用',
        advertisement: '广告',
        qualityBadge: {
          2560: '2K',
          1920: '超清',
          1280: '高清',
        },
      };
    },

    poster(state, getters) {
      return getters.post ? getters.post.video.cover : null;
    },

    qualityOptions(state, getters) {
      return getters.post
        ? getters.post.video.stream
            .map((stream: any) => stream.Width)
            .sort((a: number, b: number) => b - a)
        : null;
    },

    currentQuality(state) {
      return state.currentQuality;
    },

    controls() {
      return [
        'play-large', // The large play button in the center
        // 'restart', // Restart playback
        // 'rewind', // Rewind by the seek time (default 10 seconds)
        'play', // Play/pause playback
        // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
        'progress', // The progress bar and scrubber for playback and buffering
        'current-time', // The current time of playback
        'duration', // The full duration of the media
        'mute', // Toggle mute
        'volume', // Volume control
        // 'captions', // Toggle captions
        'settings', // Settings menu
        // 'pip', // Picture-in-picture (currently Safari only)
        'airplay', // Airplay (currently Safari only)
        // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
        'fullscreen', // Toggle fullscreen
      ];
    },

    seekTime() {
      return 5;
    },

    hideControls() {
      return true;
    },

    currentStream(state, getters) {
      return getters.post
        ? getters.post.video.stream.filter(
            (stream: any) => stream.Width === state.currentQuality,
          )[0]
        : null;
    },

    player(state) {
      return state.player;
    },

    hls(state) {
      return state.hls;
    },
  },

  /**
   * 修改器
   */
  mutations: {
    setCurrentQuality(state, data) {
      state.currentQuality = data;
    },

    setPlayer(state, data) {
      state.player = data;
    },

    setHls(state, data) {
      state.hls = data;
    },
  },

  /**
   * 动作
   */
  actions: {},

  /**
   * 模块
   */
  modules: {},
};
